import React from "react";
import { Trans, useTranslation } from "react-i18next";
import AmpNewHighlight from "../../components/common/AmpNewHighlight/AmpNewHighlight";
import Faq from "../../components/Faq/Faq";
import LookingTodoNext from "../../components/landing/LookingTodoNext/LookingTodoNext";

import "./Home.css";
// import { marketPulseEnabled } from "../../utils/configs";

export default function Home(): JSX.Element {

    const { t } = useTranslation("landing");
    const isAgent = window.localStorage.getItem("isAgent") === "Y";

    return (
        <>
            <div className="home-landing-container">
                <div className="home-landing-1">
                    <h1>
                        <Trans defaults={t("landing.home.title")}>
                            <sup></sup>
                        </Trans>
                    </h1>
                    <p>{t("landing.home.content-1-1")}</p>
                    <div className="home-landing-new-row">
                        <span>
                            <Trans defaults={t("landing.home.content-1-2")} components={{bold: <strong/>}}/>
                        </span>
                    </div>
                    {/* { marketPulseEnabled && <div className="home-landing-new-row">
                        <span>{t("landing.home.content-1-2-2")}</span>
                    </div> } */}
                    <div className="home-landing-new-row">
                        <img className="new-highlight-img pulse-img" alt="" src={"images/PropertyPulseDash.png"}/>
                        <span>
                            <Trans defaults={t("landing.home.content-1-2-2")} components={{bold: <strong/>}}/>
                        </span>
                    </div>
                
                    {!isAgent && <div className="home-landing-new-row">
                        <AmpNewHighlight
                            size="slim"
                            prefaceImage={""}
                        />
                        <span>
                            <Trans defaults={t("landing.home.content-1-2-3")} components={{bold: <strong/>}}/>
                        </span>
                    </div>}
                   
                    {/* <p>{t("landing.home.content-1-2-4")}</p> */}
                    {/* <p>{t("landing.home.content-1-3")}</p> */}
                </div>
                <div className="home-landing-2">
                    <LookingTodoNext boxes={["haw", "vmpd", "bmn", "rfr"]}/>
                </div>
            </div>
            <aside className="faq-container" aria-labelledby="faq">
                <Faq />
            </aside>            
        </>
    )
}